module.exports = __webpack_public_path__ + "static/media/footer-accueil.45f88bfa.png";